import React, {useCallback} from 'react';

import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';
import {useUserEmail} from 'src/hooks/useUserEmail';
import {getUser} from 'src/modules/admin/services';
import {Download} from 'src/modules/downloads/download';
import {getUserName} from 'src/modules/downloads/utils/get-user-name';
import {
    printSheetHeader,
    printTableData,
    printTableDataHeader,
} from 'src/modules/events/download/print-data';
import {Filters} from 'src/modules/events/typedefs';
import {EventBasicInfo} from 'src/openapi/models/EventBasicInfo';
import {useAppSelector} from 'src/store';

import {formatDate} from '@pb/kit-formatters';

type Props = {
    filters: Filters,
    events: Array<EventBasicInfo>,
};

export const EventsExcelDownload = ({filters, events}: Props) => {
    const user = useAppSelector(getUser);
    const userEmail = useUserEmail();
    const userName = getUserName(userEmail, user);

    const onDownload = useCallback(async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Events', {views: [{showGridLines: false}]});

        printSheetHeader(worksheet, userName, filters);
        printTableDataHeader(worksheet);
        printTableData(worksheet, events);

        const buffer = await workbook.xlsx.writeBuffer();
        const date = formatDate(new Date(), 'YYYY_DD_MM_H_mm_ss');

        saveAs(new Blob([buffer]), `UD_Design_Tool_Events_${date}.xlsx`);
    }, [events, filters, userName]);

    return (
        <Download onDownload={onDownload}/>
    );
};
